import flatpickr from "flatpickr";
import {French} from "flatpickr/dist/l10n/fr"
import 'flatpickr/dist/flatpickr.min.css'
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import 'flatpickr/dist/plugins/monthSelect/style.css'

const sprintf = require('sprintf-js').sprintf
flatpickr.localize(French);

export class DatePicker extends HTMLInputElement {

    connectedCallback() {

        let min = this.dataset.min
        let max = this.dataset.max
        let pattern = /^\d{4}-\d{2}-\d{2}$/;

        let config = {
            altInput: true,
            altFormat: "d/m/Y",
            dateFormat: "Y-m-d",
            allowInput: true,
            minDate: sprintf('%s-%s-%s', (new Date()).getFullYear() - 70, "01", "01"),
            maxDate: sprintf('%s-%s-%s', (new Date()).getFullYear() + 10, "12", "31"),
            locale: {
                "firstDayOfWeek": 1 // start week on Monday
            }
        }
        if (min !== undefined && pattern.test(min)) {
            config.minDate = min;
        }

        if (max !== undefined && pattern.test(max)) {
            config.maxDate = max;
        }

        this.date = flatpickr(this, config);


    }

    disconnectedCallback() {
        this.date.destroy()
    }
}

export class DatePickerTwo extends HTMLInputElement {

    connectedCallback() {
        this.date = flatpickr(this, {
            altInput: true,
            mode: "range",
            altFormat: "d/m/Y",
            dateFormat: "Y-m-d",
            allowInput: true
        });
    }

    disconnectedCallback() {
        this.date.destroy()
    }
}

export class TimePicker extends HTMLInputElement {

    connectedCallback() {
        this.date = flatpickr(this, {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            minTime: "08:00",
            maxTime: "17:30",
            time_24hr: true,
        });
    }

    disconnectedCallback() {
        this.date.destroy()
    }
}

export class MonthPicker extends HTMLInputElement {

    connectedCallback() {
        this.date = flatpickr(this, {
            plugins: [
                new monthSelectPlugin({
                    shorthand: true, //defaults to false
                    dateFormat: "F Y", //defaults to "F Y"
                    altFormat: "m.y",
                })
            ]
        });
    }

    disconnectedCallback() {
        this.date.destroy()
    }
}
